import React from 'react'
import IndexComponent from './IndexComponent'
import  useWpJson  from '../../Hooks/useWpJson'
export default function FeaturedGallery ({ pageName,gallery }) {
  const ids = gallery?.map(({ ID }) => ID).join(',')
  const catId = useWpJson(`posts?include=${ids}&acf_format=standard`)
  return <IndexComponent gallery={catId} id={pageName} />
}
